import WidgetModule from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber";

export * from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber";

export default WidgetModule;
